// extracted by mini-css-extract-plugin
export default {"ModalHeader":"ModalHeader","ModalHeader-content":"ModalHeader-content","ModalHeader-button-group":"ModalHeader-button-group","ModalHeader-cancel":"ModalHeader-cancel"};